import React from 'react'
import MessageLayout from '../components/layout/Message'

const BlockedAccount = () => {
  return <MessageLayout title={`Your account has been blocked.`} />
}

export default BlockedAccount
